const appConfig = {
  apiBaseURL: process.env["REACT_APP_API_BASE_URL"],
  apiKeyCloakURL: process.env["REACT_APP_KEYCLOAK_URL"],
};

export default appConfig;
